import React from 'react';
import ReactDOM from 'react-dom';
import styles from './Css/ImageFlyPortal.module.css';

const ImageFlyPortal = ({ imgSrc, isFlying, onAnimationEnd }) => {
    if (!isFlying) return null;

    return ReactDOM.createPortal(
        <img
            src={imgSrc}
            alt="Flying image"
            className={styles.flyingImage}
            onAnimationEnd={onAnimationEnd}
        />,
        document.body
    );
};

export default ImageFlyPortal;